export default __webpack_public_path__ + "static/media/checkmark.a71ef8dc.svg";